import React, { FC, useEffect } from 'react'
import { endOfDay, startOfDay } from 'date-fns'
import { FormProvider, useForm } from 'react-hook-form'
import { useDispatch } from 'react-redux'
import { CommissionsStatusEnum, ReadCommissionsRequestDto } from '@sparling/financial-common'
import { DataPicker } from '../../../components/DatePicker'
import { FilterSelect } from '../../../components/FilterSelect'
import { CRM_COMMISSIONS_STATUS } from '../../../constants/CrmCommissions'
import { Search } from '../../../components/Search'
import { getCommissionsRequest, resetCommissionsFilters } from '../../../store/actions'

interface IFilters {
  fromDate?: string
  toDate?: string
  status?: string
  search?: string
}

export const CommissionsFilters: FC = () => {
  const dispatch = useDispatch()
  const formMethods = useForm<IFilters>({ mode: 'onChange' })
  const { watch, getValues } = formMethods

  useEffect(() => {
    dispatch(resetCommissionsFilters())
  }, [dispatch])

  useEffect(() => {
    const subscription = watch(() => {
      const { status, ...rest } = getValues() as ReadCommissionsRequestDto
      dispatch(
        getCommissionsRequest({
          ...rest,
          status: status
            ? Object.values(CommissionsStatusEnum).find((value) => value.replace(/\s/g, '_') === status) || status
            : undefined,
        }),
      )
    })

    return () => subscription.unsubscribe()
  }, [dispatch, getValues, watch])

  return (
    <FormProvider {...formMethods}>
      <DataPicker
        placeholder={'Start Date'}
        margin="8px 8px 8px 0"
        dataPickerName={'fromDate'}
        required={false}
        maxDate={getValues().toDate}
        formatValue={startOfDay}
      />
      <DataPicker
        placeholder={'End Date'}
        margin={8}
        dataPickerName={'toDate'}
        required={false}
        minDate={getValues().fromDate}
        formatValue={endOfDay}
      />
      <FilterSelect
        inputName={'status'}
        placeholder="Status"
        enums={CRM_COMMISSIONS_STATUS}
        width={140}
        ml={8}
        mr={8}
      />
      <Search pr={8} pl={8} inputName={'search'} />
    </FormProvider>
  )
}
